module.exports = __webpack_public_path__ + "static/media/powered-by-iox.134144b1.png";